import { render, staticRenderFns } from "./UserResultsGrid.vue?vue&type=template&id=3bed5e30&"
import script from "./UserResultsGrid.vue?vue&type=script&lang=js&"
export * from "./UserResultsGrid.vue?vue&type=script&lang=js&"
import style0 from "./UserResultsGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports